import {
    hasEnabledFeature,
    hasRestrictedRole,
    isdvirOnly,
    objectArrayFromMultipleFields
} from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import ViewForm from './Form';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const AdvancedDvir = lazy(() => import(`@/modules/AdvancedDvir`));
const CustomDvir = lazy(() => import(`@/modules/CustomDvir`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const DatePopup = lazy(() => import(`@/modules/DatePopup/${layout}`));

const TopActions = ({
  isCustomDviRequired,
  isAdvancedDviRequired,
  i18n,
  history,
  list,
  bulkDownloadReport,
  apiStatus,
  clearApiStatus,
  callback,
  Styled,
  changeRequest,
  hasApiStatus,
  filters,
  setPagination
}) => {
  const [isExportClicked, setIsExportClicked] = useState(false);
  const isDvirOnlyFlagEnabled = isdvirOnly();

  const userList = objectArrayFromMultipleFields(list?.drivers, 'id', [
    'firstName',
    'lastName'
  ]);

  const downloadTypes = [
    { label: 'DVIR', value: 'DVIR' },
    ...(isDvirOnlyFlagEnabled ? [] : [{ label: 'DOT', value: 'DOT' }]),
    { label: 'POST-TRIP', value: 'POST_TRIP' },
    { label: 'PRE-TRIP', value: 'PRE_TRIP' }
  ];

  const handleBulkDownloadClick = () => {
    if (window.$environment.SERVICE_PROVIDER === 'spireon') {
      setIsExportClicked((prev) => !prev);
    } else {
      setIsExportClicked(true);
    }
  };

  const renderButtons = () => (
    <>
      {isCustomDviRequired && (
        <FormStyle.default.ButtonsWrapper className="advancedDVIR">
          <CustomDvir
            className="buttonStyle"
            label={i18n.t('inspections.customDvir')}
            history={history}
          />
        </FormStyle.default.ButtonsWrapper>
      )}
      {isAdvancedDviRequired && (
        <FormStyle.default.ButtonsWrapper
          className={layout === 'SpireonNew' ? '' : 'advancedDVIR'}
        >
          <AdvancedDvir
            className="buttonStyle"
            label={i18n.t('inspections.advancedDvir')}
            history={history}
          />
        </FormStyle.default.ButtonsWrapper>
      )}
      {hasEnabledFeature('bulkDownloadEnabled') && (
        <FormStyle.default.ButtonsWrapper className="bulkDownload">
          <Button
            type="submit"
            className="buttonStyle"
            label={i18n.t('inspections.bulkDownloadReport')}
            onClick={handleBulkDownloadClick}
          />
        </FormStyle.default.ButtonsWrapper>
      )}
    </>
  );

  return (
    <Styled.Wrapper>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <div className="buttonWrapper">
        {!hasRestrictedRole(['DRIVER', 'MECHANIC']) && renderButtons()}
      </div>
      {!hasRestrictedRole(['DRIVER', 'MECHANIC']) && (
        <DatePopup
          formId="bulkDownloadForm"
          isOpen={isExportClicked}
          setIsOpen={setIsExportClicked}
          submit={bulkDownloadReport}
          apiStatus={apiStatus}
          clearApiStatus={clearApiStatus}
          data={list?.list || []}
          callback={callback}
          drivers={userList}
          downloadTypes={downloadTypes}
          inspections
        />
      )}
      <ViewForm
        apiStatus={apiStatus}
        history={history}
        callback={callback}
        Styled={Styled}
        hasApiStatus={hasApiStatus}
        changeRequest={changeRequest}
        list={list}
        setPagination={setPagination}
      />
      {layout === 'OldUi' && (
        <div className="breadcrumbClass">
          <Breadcrumb filters={filters} />
        </div>
      )}
    </Styled.Wrapper>
  );
};

export default TopActions;